import { render, staticRenderFns } from "./MediaArticles.vue?vue&type=template&id=1d8ec488&scoped=true&"
import script from "./MediaArticles.vue?vue&type=script&lang=js&"
export * from "./MediaArticles.vue?vue&type=script&lang=js&"
import style0 from "./MediaArticles.vue?vue&type=style&index=0&id=1d8ec488&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8ec488",
  null
  
)

export default component.exports